import Typography from '@Components/typo'
import { PropsWithChildren } from 'react'
import Layout from '.'
import { NavbarResponse } from '../../apis/navbar'
import LayoutWithSpacing from './layoutWithSpacing'
import { FooterResponse } from '../../apis/footer'

interface PageLayoutProps extends PropsWithChildren {
  navbar?: NavbarResponse
  footer?: FooterResponse
  title?: string
  layoutVariant?: 'primary' | 'secondary'
  className?: string
  subTitle?: JSX.Element
}

const PageLayout = ({
  navbar,
  footer,
  title,
  children,
  layoutVariant,
  className,
  subTitle,
}: PageLayoutProps) => {
  return (
    <Layout navbar={navbar} footer={footer} className={className}>
      <LayoutWithSpacing
        className='mt-20 flex flex-col gap-8'
        variant={layoutVariant}
      >
        {title && (
          <div className='flex justify-between gap-4'>
            <Typography
              size='h4'
              weight='bold'
              color='text-content-default'
              className='flex-1'
            >
              {title}
            </Typography>
            {subTitle}
          </div>
        )}
        {children}
      </LayoutWithSpacing>
    </Layout>
  )
}

export default PageLayout
